import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { NavLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

export default class AlternaModulos extends Component {

    render() {

        let configuracao = this.props.configuracao;
        let exibeFechar = this.props.exibeFechar;
        const acessaBackOffice = this.props.configuracao?.modulos?.find(x => x.nome === "Backoffice");
        const acessaDashBoard = this.props.configuracao?.modulos?.find(x => x.nome === "Dashboard");
        const acessaComunicacao = this.props.configuracao?.modulos?.find(x => x.nome === "Comunicação");
        const acessaCantina = this.props.configuracao?.modulos?.find(x => x.nome === "Cantina");
        const acessaDiario = this.props.configuracao?.modulos?.find(x => x.nome === "Diário Escolar" || x.nome === "Diário de Classe");
        // Decoupla a exibição do card "Educar" da permissão de Backoffice.
        // Exibe "Educar" quando o usuário tem autorização para o módulo de Escolas
        // (menos permissões do que Backoffice). Caso a configuração ainda não esteja
        // reidratada, mostramos o card por padrão.
        const podeAcessarEducar = (() => {
            try {
                return this.props.configuracao?.modulos?.find(x => x.nome === "Gestão Escolar")
                
                // // Se a configuração ainda não está carregada, não bloqueia a exibição do card
                // if (!Array.isArray(cfg.menus)) {
                //     return true;
                // }

                // // Educar requer menos permissão: basta existir o item "Escolas" OU "Alunos" nos menus
                // for (let i = 0; i < cfg.menus.length; i++) {
                //     const menu = cfg.menus[i];
                //     for (let j = 0; j < (menu.itensDoMenu || []).length; j++) {
                //         const item = menu.itensDoMenu[j] || {};
                //         const isEscolas = String(item.path || '').toLowerCase() === 'escolas' || String(item.descricaoItem || '') === 'Escolas';
                //         const isAlunos = String(item.path || '').toLowerCase() === 'alunos' || String(item.descricaoItem || '') === 'Alunos';
                //         if (isEscolas || isAlunos) {
                //             return true;
                //         }
                //     }
                // }
                // return false;
            } catch (e) {
                return true;
            }
        })();
        return (<Fragment>
            <div style={{ flexGrow: 1 }}>
                <Grid style={{ marginTop: 10, textAlign: 'right' }} container spacing={3}>
                    <Grid item xs={12}>
                        {
                            exibeFechar &&
                            <Button startIcon={<CloseIcon style={{ color: '#05B59D' }} />} color="primary" style={{ marginRight: 8, padding: '14px 36px', borderRadius: 100, borderWidth: 2 }} variant="outlined" onClick={() => { this.props.funcaoFechar(); }}>
                                <span style={{ fontStyle: 'normal', fontFamily: 'Montserrat, sans-serif', fontWeight: 'bold', fontSize: '14px', letterSpacing: '1.25px', textTransform: 'none' }}>Fechar</span>
                            </Button>
                        }

                    </Grid>
                </Grid>
            </div>

            <Grid style={{ minHeight: 330, marginTop: 10, display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '100%' }} container spacing={3}>
              
                    {acessaBackOffice &&<Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Backoffice', this.props.configuracao) }}>
                            <NavLink className="prepend-icon" to="/app/inicio">
                                <div style={{ height: '82%', width: 175, margin: 14 }} className="jr-card bg-gradient-primary text-white text-center ripple-effect">
                                    <div className=" mt-xl-1">
                                        <i className="zmdi zmdi-account-box-o zmdi-hc-2x"></i>
                                    </div>
                                    <h5 className="text mb-xl-1">Backoffice</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>}
                

                {podeAcessarEducar && (
                    <Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Educar', this.props.configuracao) }}>
                            <NavLink className="prepend-icon" to="/app/inicio">
                                <div
                                    style={{ height: '82%', width: 175, margin: 14 }}
                                    className="jr-card bg-gradient-primary text-white text-center ripple-effect"
                                >
                                    <div className="mt-xl-1">
                                        <i className="zmdi zmdi-book zmdi-hc-2x"></i>
                                    </div>
                                    <h5 className="text mb-xl-1">Gestão Escolar</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>


                )}

                {/* {acessaDashBoard && (
                    <Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Dashboard', this.props.configuracao) }}>
                            <NavLink className="prepend-icon" to="/app/inicio">
                                <div
                                    style={{ height: '82%', width: 175, margin: 14 }}
                                    className="jr-card bg-gradient-primary text-white text-center ripple-effect"
                                >
                                    <div className="mt-xl-1">
                                        <i className="zmdi zmdi-view-dashboard zmdi-hc-2x"></i>
                                    </div>
                                    <h5 className="text mb-xl-1">Dashboard</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>
                )} */}

                {acessaComunicacao && (
                    <Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Comunicação', configuracao) }}>
                            <NavLink className="prepend-icon" to="/app/inicio">
                                <div
                                    style={{ height: '82%', width: 175, margin: 14 }}
                                    className="jr-card bg-gradient-primary text-white text-center ripple-effect"
                                >
                                    <div className="mt-xl-1">
                                        <i className="zmdi zmdi-notifications-active zmdi-hc-2x"></i>
                                    </div>
                                    <h5 className="text mb-xl-1">Comunicação</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>
                )}

                {acessaCantina && (
                    <Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Cantina', configuracao) }}>
                            <NavLink className="prepend-icon" to="/cantina">
                                <div
                                    style={{ height: '82%', width: 175, margin: 14 }}
                                    className="jr-card bg-gradient-primary text-white text-center ripple-effect"
                                >
                                    <div className="mt-xl-1">
                                        <i className="zmdi zmdi-cutlery zmdi-hc-2x"></i>
                                    </div>
                                    <h5 className="text mb-xl-1">Cantina</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>
                )}
                {acessaDiario && (
                    <Grid item>
                        <div style={{ cursor: 'pointer' }} onClick={() => { this.props.irParaModulo('Diário Escolar', configuracao) }}>
                            <NavLink className="prepend-icon" to="/diario-escolar">
                                <div
                                    style={{ height: '82%', width: 175, margin: 12 }}
                                    className="jr-card bg-gradient-primary text-white text-center ripple-effect"
                                >
                                    <div className="mt-0">
                                        <img src="/class_1.png" alt="Diário Escolar" style={{ height: 30, marginBottom: 4 }} />
                                    </div>
                                    <h5 className="text mb-xl-1">Diário Escolar</h5>
                                </div>
                            </NavLink>
                        </div>
                    </Grid>
                )}
            </Grid>
        </Fragment>
        );
    }
}